import(/* webpackMode: "eager", webpackExports: ["SEOLandingPageV2"] */ "/vercel/path0/apps/repetix/app/components/seo/SEOLandingPageV2.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.21_@babel+core@7.28.5_@opentelemetry+api@1.9.1_@playwright+test@1.56.1_@types_4097594c5fb020379b979c1ac70f016a/node_modules/next/dist/client/script.js");
